import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { api, fmtUsd, fmtPct, fmtTime } from "@/lib/api";
import { SectionTitle, Badge } from "@/components/Bits";

export default function OpenPositions() {
  const [rows, setRows] = useState([]);

  const load = async () => { try { setRows(await api.openPositions() || []); } catch {} };
  useEffect(() => { load(); const id = setInterval(load, 4000); return () => clearInterval(id); }, []);

  const close = async (id) => {
    try { await api.closePosition(id); toast.success("Position closed"); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || e.message); }
  };

  return (
    <div className="p-6 space-y-6">
      <SectionTitle sub={`${rows.length} open paper position${rows.length === 1 ? "" : "s"}.`}>
        Open Positions
      </SectionTitle>

      <div className="bg-[#0F0F14] border border-border rounded-sm overflow-x-auto">
        <table className="w-full text-sm" data-testid="open-positions-table">
          <thead className="text-[10px] uppercase tracking-widest text-[#71717A]">
            <tr>
              <th className="text-left px-4 py-3">Side</th>
              <th className="text-left px-4 py-3">Symbol</th>
              <th className="text-right px-4 py-3">Entry</th>
              <th className="text-right px-4 py-3">Size (BTC)</th>
              <th className="text-right px-4 py-3">Notional</th>
              <th className="text-right px-4 py-3">Lev</th>
              <th className="text-right px-4 py-3">uPnL</th>
              <th className="text-right px-4 py-3">PnL %</th>
              <th className="text-left px-4 py-3">Opened</th>
              <th className="text-right px-4 py-3"></th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr><td colSpan={10} className="px-4 py-8 text-center text-[#71717A]">No open positions.</td></tr>
            ) : rows.map((p) => (
              <tr key={p.id} className="border-t border-border/60">
                <td className="px-4 py-3"><Badge kind={p.side === "LONG" ? "long" : "short"}>{p.side}</Badge></td>
                <td className="px-4 py-3 font-mono">{p.symbol}</td>
                <td className="px-4 py-3 cell-num">${fmtUsd(p.entry_price)}</td>
                <td className="px-4 py-3 cell-num">{Number(p.size).toFixed(6)}</td>
                <td className="px-4 py-3 cell-num">${fmtUsd(p.notional_usdt)}</td>
                <td className="px-4 py-3 cell-num">{p.leverage}x</td>
                <td className={`px-4 py-3 cell-num ${p.unrealized_pnl >= 0 ? "long-text" : "short-text"}`}>{p.unrealized_pnl >= 0 ? "+" : ""}${fmtUsd(p.unrealized_pnl)}</td>
                <td className={`px-4 py-3 cell-num ${(p.pnl_percent || 0) >= 0 ? "long-text" : "short-text"}`}>{fmtPct(p.pnl_percent || 0)}</td>
                <td className="px-4 py-3 font-mono text-xs text-[#A0A0AB]">{fmtTime(p.opened_at)}</td>
                <td className="px-4 py-3 text-right">
                  <Button data-testid={`close-${p.id}`} size="sm" variant="outline" onClick={() => close(p.id)} className="rounded-sm border-border bg-[#1A1A22] hover:bg-[#262633]">
                    Close
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
